import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { INonMovementTransactionLinesFilter } from '../interfaces/non-movement-transaction-lines-filter';
import {
  INonMovementTransaction,
  INonMovementTransactionHistory,
} from '../interfaces/non-movement-transaction';

@Injectable({ providedIn: 'root' })
export class NonMovementTransactionService extends ReadService<any, any> {
  url = '/api/non-movement-transaction';
  entityTitle = 'Non Movement Transaction';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(filter: INonMovementTransactionLinesFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.http
      .get(`${this.url}`, { headers: new HttpHeaders({}), params: params })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public create(dto: any) {
    const url = `${this.url}`;
    return this.handleRequest<any[]>(
      this.http.post<any[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public update(id: number, dto: any) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<any>(
      this.http.put<any>(url, dto),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  public delete(id: number) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<any>(
      this.http.delete<any>(url),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  public getPrefixes(excludeDefault: boolean): Promise<any> {
    return this.http
      .get(`${this.url}/prefixes/${excludeDefault}`, { headers: new HttpHeaders({}) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public processTransactions(ids: number[]) {
    const url = `${this.url}/process-transactions`;
    return this.handleRequest<any[]>(
      this.http.post<any[]>(url, ids),
      this.handlersFactory.getDefault(),
    );
  }

  public deleteTransactions(ids: number[]) {
    const url = `${this.url}/delete-transactions`;
    return this.handleRequest<any[]>(
      this.http.post<any[]>(url, ids),
      this.handlersFactory.getDefault(),
    );
  }
  public getHistory(id: number): Promise<INonMovementTransactionHistory[]> {
    return this.http
      .get(`${this.url}/histories/${id}`, { headers: new HttpHeaders({}) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  public searchTransactions(query: string): Promise<INonMovementTransaction[]> {
    return this.http
      .get(`${this.url}/search/${query}`, { headers: new HttpHeaders({}) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public getHistoryTimelineFromTransactionHistories(
    transactionHistories: INonMovementTransactionHistory[],
  ) {
    let timelineItems = [];
    transactionHistories.forEach((x) => {
      timelineItems.push({
        time: x.createdOn,
        header: `${x.createdByFirstName} ${x.createdByLastName}`,
        content: x.summary,
        historyType: 'time',
      });
    });
    return timelineItems;
  }
}
